import { useEffect } from "react";
import { useTheme } from "../context/ThemeContext";
import Layout from "./Layout";
import { Menu } from "lucide-react";

export default function About() {
  const { isDark } = useTheme();

  // Scroll to top when page loads
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Layout>
      {({ toggleMobileMenu }) => (
        <div className="flex flex-col items-center px-4 py-6 sm:px-6 sm:py-8 lg:px-10 lg:py-12">
          <div className="w-full max-w-content">
            {/* Mobile Menu Button */}
            <div className="mb-8 lg:hidden">
              <button
                onClick={toggleMobileMenu}
                className={`p-2 rounded-lg ${
                  isDark
                    ? "text-gray-400 hover:text-white hover:bg-gray-700"
                    : "text-text-muted hover:text-text hover:bg-gray-100"
                }`}
                aria-label="Toggle menu"
              >
                <Menu size={20} />
              </button>
            </div>

            {/* Page Header */}
            <header className="mb-12">
              <h1
                className={`text-4xl font-display font-semibold mb-8 tracking-tight ${
                  isDark ? "text-white" : "text-text"
                }`}
              >
                About me
              </h1>

              {/* Bio */}
              <div
                className={`space-y-5`}
                style={{
                  fontSize: "1rem",
                  lineHeight: "1.75",
                  fontWeight: "400",
                  color: isDark
                    ? "oklch(55% 0.013 144.91)"
                    : "oklch(35% 0.013 144.91)",
                }}
              >
                <p>
                  Hey I'm Muyi, an engineer that's mostly interested in solving
                  software related problems and lover of automation. Majority of
                  the time I'm learning or I'm building/collaborating on
                  softwares that solve problems.
                </p>
                <p>
                  I have strong opinions and convictions that are weakly held
                  and love to be challenged! Feel free to reach out, I'd love to
                  connect.
                </p>
              </div>
            </header>

            {/* About Blog Section */}
            <section className="mb-12">
              <h2
                className={`text-3xl font-display font-semibold mb-6 tracking-tight ${
                  isDark ? "text-white" : "text-text"
                }`}
              >
                About blog
              </h2>
              <p
                className={`mb-4`}
                style={{
                  fontSize: "1rem",
                  lineHeight: "1.75",
                  fontWeight: "400",
                  color: isDark
                    ? "oklch(55% 0.013 144.91)"
                    : "oklch(35% 0.013 144.91)",
                }}
              >
                This blog is mostly about:
              </p>
              <ul
                className={`list-disc pl-8 space-y-2 mb-6`}
                style={{
                  fontSize: "1rem",
                  lineHeight: "1.75",
                  fontWeight: "400",
                  color: isDark
                    ? "oklch(55% 0.013 144.91)"
                    : "oklch(35% 0.013 144.91)",
                }}
              >
                <li>
                  Me learning new things (understanding and fixing my failures
                  along the way).
                </li>
                <li>
                  Backend approaches, guides and practices that I applied.
                </li>
                <li>DevOps Journey, challenges and Implementations.</li>
                <li>Implementing algorithms and System designs in software.</li>
              </ul>
              <p
                style={{
                  fontSize: "1rem",
                  lineHeight: "1.75",
                  fontWeight: "400",
                  color: isDark
                    ? "oklch(55% 0.013 144.91)"
                    : "oklch(35% 0.013 144.91)",
                }}
              >
                I mostly post about things I work on, stumble upon and new
                things I learn in my journey as a software engineer.
              </p>
            </section>
          </div>
        </div>
      )}
    </Layout>
  );
}
